<template>
  <v-app id="inspire">
    <v-navigation-drawer
      clipped
      fixed
      v-model="drawer"
      app
    >
     <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
            {{current_buyer.name}}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-divider></v-divider>
      <v-list>
        <v-list-tile @click="">
          <v-list-tile-action>
            <v-icon>book</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>キャンペーン</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="">
          <v-list-tile-action>
            <v-icon>bookmarks</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>広告グループ</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="">
          <v-list-tile-action>
            <v-icon>bookmark_border</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>クリエイティブ</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <img src="../assets/logo.png" class="header_logo"/>
      </v-toolbar-title>
      <v-menu :nudge-width="100">
        <v-toolbar-items slot="activator">
          <v-btn flat>
            {{current_buyer.name}}
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-list>
          <v-list-tile
            v-for="buyer in buyers"
            :key="buyer.id"
            @click="setCurrentBuyer(buyer)"
          >
            <v-list-tile-title v-text="buyer.name"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat @click="logout();">
          <v-icon>logout</v-icon>
          ログアウト
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container>
        <router-view/>
      </v-container>
    </v-content>
    <v-footer app fixed>
      <span>　&copy; NTT Docomo, Inc 2018</span>
    </v-footer>
  </v-app>
</template>

<script>

import axios from 'axios'

export default {
  name: 'Dashboard',
  data () {
    return {
      drawer: false,
      msg: "広告主一覧",
      buyers: [], 
      current_buyer: {}
    }
  }, 
  methods: {
    logout: function(){
      localStorage.removeItem("token");
      this.$router.push('/login');      
    },
    setCurrentBuyer: function(buyer) {
      this.current_buyer = buyer;
      this.$router.push({ path: `/dashboard/campaigns/${this.current_buyer.id}`});
    }
  },
  props: {
    source: String
  },
  created () {
  const self = this
  let params = new URLSearchParams();
  params.append('session', localStorage.token);
  axios
    .post('https://ad.ec-concier.com/adlogue/user.json/buyer/select',params)
    .then((res) => {
      self.buyers = res.data.list.data
      self.current_buyer = res.data.list.data[0]
      self.$router.push({ path: `/dashboard/campaigns/${self.current_buyer.id}`});
    });
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header_logo {
    height: 22px;
    width: 130px;
    margin-top: 10px;
    margin-right: 20px
 
 }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue